import React from "react";
import WordCloudComponent from "../commons/WordCloudComponent";

function TextChartComponent(props) {

    return (
        <React.Fragment>
            <WordCloudComponent
                isMobile={props.isMobile}
                chartIndex={props.chartIndex}
                selectIndex={null}
                updateChartInfo={props.updateChartInfo}
                chartConfig={props.configuration}
                answersData={props.questionAnswers}
                questionId={props.questionData.question.question_id}
                questionTitle={props.questionData.question.id + ". " + props.questionData.question.question}/>
        </React.Fragment>)
}

export default TextChartComponent;